import { ERROR_IN_THE_RELEASED_NETWORK } from '@/services/constraints/errorMessages'

import { NetworkExportErrors } from './getReleaseErrorsForAVariable'

// Thrown so a blocked release keeps flowing through `mutationWithFeedback`'s
// error path (its toast and the tagging that suppresses the global fallback
// toast stay as they were) while still carrying the errors to the dialog, which
// is the only place that can name the offending nodes on screen.
export class ReleaseValidationError extends Error {
  readonly errors: NetworkExportErrors[]

  constructor(errors: NetworkExportErrors[]) {
    super(ERROR_IN_THE_RELEASED_NETWORK)
    this.name = 'ReleaseValidationError'
    this.errors = errors
  }
}
